import appModuleRegistry from "components/appModules/appModuleRegistry";
import { LocalStorage } from "components/appModules/LocalStorage";
import { Component } from "components/components/Component";
import { LinkTree } from "components/linkTree/linkTree";
import { Renderer } from "components/Renderer";
import { S6Request } from "components/request/request";
import { Router } from "components/router/router";
import $ from "jquery";
import template from "./dashboard.hbs";

export class MainDashboard implements Component {
    public readonly componentType = "mainDashboard";
    public readonly id: string;
    public readonly definition: MainDashboardDefinition;
    private view: Element;
    private activeRequests = 0;
    private uniqueLink: string;
    private isUnique =  true;

    constructor(definition: MainDashboardDefinition) {
        this.definition = definition;
        if (this.definition.widgets == null) {
            this.definition.widgets = MainDashboard.applicationWidgets();
        }
        this.id = this.definition.id || "s6-main-dashboard";
    }

    public render(): Element {
        this.definition.widgets.forEach((widgetSrc) => {

            this.activeRequests++;
            const url = widgetSrc.appBaseUrl + widgetSrc.path + ".json";
            S6Request.url(url).get()
                .res((data) => {
                    if (data != null) {
                        data.forEach((widget) => {
                            widget.order = widget.order || 9999;
                            const p = this.findPrevious(widget.order);
                            const container =
                                $("<div class='main-dashboard-widget' data-s6-dashboard-order='" + widget.order + "'>");
                            if (p == null) {
                                this.view.prepend(container[0]);
                            } else {
                                p.after(container[0]);
                            }
                            Renderer.instance().fullComponentRender(widget, container[0]);
                            if (widget.componentType=== "linkTree" && this.isUnique === true) {
                                const unique = LinkTree.getUniqueLink(widget);
                                if (unique != null && this.uniqueLink != null || unique == null) {
                                    this.isUnique = false;
                                } else {
                                    this.uniqueLink = LinkTree.getUniqueLink(widget);
                                }
                            }
                        });
                    } else {
                        console.error("error loading widget");
                        Router.getInstance().navigate("/logout");
                    }
                    this.activeRequests--;
                    if (this.activeRequests == 0) {
                        //finished
                        if (this.isUnique && this.uniqueLink != null) {
                            Router.getInstance().navigate(this.uniqueLink);
                        }
                    }
                })
                .catch((ex) => {
                    console.error("parsing failed", ex);
                    Router.getInstance().navigate("/logout");
                });
        });
        const d = document.createElement("div");
        d.innerHTML = template(this.definition);

        this.view = d.firstChild as HTMLElement;
        return this.view;
    }

    private findPrevious(order: number) {
        let p: Element;
        $(this.view).find("div.main-dashboard-widget").each((i, v) => {
            if (Number(v.getAttribute("data-s6-dashboard-order"))  >= order) {
                return;
            }
            p = v;
        });
        return p;
    }

    private static applicationWidgets(): WidgetReferenceDefinition[] {
        const uid = LocalStorage.getUid();
        if (uid == null) {
            Router.getInstance().logout();
        }
        const widgets = [];
        for (const appModule of appModuleRegistry.nonCoreApps) {
            widgets.push({
                appBaseUrl: appModule.baseUrl,
                path: "/widgets/" + uid,
            });
        }
        return widgets;
    }
}

export interface MainDashboardDefinition {
    id: string;
    componentType; string;
    widgets: WidgetReferenceDefinition[];
}

export interface WidgetReferenceDefinition {
    appBaseUrl: string;
    path: string;
}
